import * as classes from './Cards.module.css'

const Cards = ({ title, cards }) => {
  if (!cards || !cards.length) return (<></>)

  return (
    <section className={`container-md ${classes.sectionCards}`}>
      <div className='container-text'>
        {title && <h2>
          {title}
        </h2>}
        <div className={classes.cards}>
          {cards.map(card => (<div className={classes.card} key={card.sys.id}>
            {card.fields.image && <div className={classes.cardImg}>
              <img
                src={card.fields.image.fields?.file?.url}
                alt={card.fields.image.fields?.title}
                width={card.fields?.image?.fields?.file?.details?.image?.width}
                height={card.fields?.image?.fields?.file?.details?.image?.height}
              />
            </div>}
            {card.fields?.title && <h3>{card.fields.title}</h3>}
            {card.fields.description && <div>{card.fields.description}</div>}
          </div>))}
        </div>
      </div>
    </section>
  )
}

export default Cards
